import angular from 'angular';

import '../controller/environment';

const getCountryCodeFromUrl = (location = window.location) => {
    // Assumes the country code is the first part after the hostname
    // e.g. https://portal.aferpay.com/us/login-email
    const urlParts = (location.href || "").split("/");
    const countryCodePartIndex = 3;
    let countryCode = "";
    if (urlParts?.length && urlParts.length >= countryCodePartIndex) {
        countryCode = urlParts[countryCodePartIndex] || "";
    }
    // PAYL-7691 The ISO country code for the United Kingdom is "GB" (which is saved in the backend database)
    // however the consumer facing urls should always use "UK" instead of "GB".
    // This is because the consumers in that area will always use "United Kingdom" to refer to their location
    countryCode = countryCode === "uk" ? "gb" : countryCode; // UK should be GB
    return countryCode.toUpperCase();
};

export const Country = {
    getCountryCodeFromUrl
}

angular.module("core.application.main").factory("core.application.main.factory.country", [
    "$resource", "$location", "core.application.main.controller.environment",
    function($resource, $location, Environment) {

        var expose = {};
        var resourceCountries = $resource(Environment.MERCHANT_PORTAL_API_BASE_URL + "/countries");

        expose.readCountries = function(parameters, success, error) {
            resourceCountries.get(parameters, success, error);
        };

        expose.getCountryCodeFromUrl = getCountryCodeFromUrl

        return expose;

    }
]);
